export default {
  'AI Face Animator': 'Efectos Faciales de AI',
  'Create incredible facial expressions with brainwashing music, find the magic for fun.': 'Expresiones mágicas, Brainwash música, disfruta de todo al máximo.',
  'Upload a photo': 'Subir una foto',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.': 'Nota: En la foto seleccionada, la cara debe mirar hacia la cámara; de ​​lo contrario, no se puede procesar correctamente.',
  'Uploaded successfully!': '¡Subido con éxito!',
  'Please select a template below': 'Selecciona una plantilla abajo',
  'Choose a GIF': 'Elegir una GIF',
  'Use this template': 'Selecciona esto',
  'Verify successfully! You will': '¡La verificación es exitosa! ¡Pronto recibirás el video a través de {{email}}!',
  'You will': '¡Pronto recibirás el video a través de {{email}}!',
  'What you should expect to happen next': '¿Qué pasará después:',
  'We will process your photo into a dynamic video.': 'Procesaremos tu imagen en un video animado.',
  'After processing, we will send the video to your email.': 'Una vez procesado, enviaremos el video a tu buzón.',
  'You can check the video in your email.': 'Puedes consultar el video en tu buzón.',
  'Your video will be delivered via email': 'Te enviaremos el video por correo electrónico',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.': 'Die Synthese des dynamischen Videos dauert 20 bis 30 Minuten. Bitte haben Sie etwas Geduld. Um Ihre Privatsphäre zu schützen, werden die hochgeladenen Bilder nach Abschluss der Verarbeitung automatisch gelöscht.',
  'Your Email': 'Tu buzón',
  'Last Name': 'Apellido',
  'First Name': 'Nombre',
  'Go back': 'Regreso',
  'Invalid email address':'Email inválido',
  'Enter verification code':'Introducir el código de confirmación',
  'Enter the verification code that we sent to': 'Introducir el código de verificación que enviamos a {{email}}.',
  'Resend': 'Reenviar',
  'Verification code': 'Código de verificación',
  'Resend after': 'Reenviar después de los {{num}} segundos',
  'The verification code is invalid. You can request a new one.': 'Código de verificación no válido, puedes solicitar el código de verificación nuevamente.',
  'Synthesize Video': 'Unir videos',
  'Too many attempts, please try again later.': 'Demasiados intentos. Por favor pruebe mas tarde.',
}